<p>show-rule works!</p>
